import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=ba1d29b4&scoped=true&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetPage.vue?vue&type=style&index=0&id=ba1d29b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1d29b4",
  null
  
)

export default component.exports